import styled from '@emotion/styled';
import AppsIcon from '@mui/icons-material/Apps';
import ListIcon from '@mui/icons-material/List';
import { shouldForwardProp } from '../../utils/emotion';

type FileLayoutSelectorLayout = 'grid' | 'list';

type FileLayoutSelectorProps = {
  className?: string;
  selected: FileLayoutSelectorLayout;
  onSelect: (layout: FileLayoutSelectorLayout) => void;
};

const FileLayoutSelector = ({ className, onSelect, selected }: FileLayoutSelectorProps) => {
  const handleClick = (layout: FileLayoutSelectorLayout) => () => {
    onSelect(layout);
  };

  return (
    <Root className={className}>
      <IconButton
        type="button"
        aria-label="Grid view"
        aria-pressed={selected === 'grid'}
        $active={selected === 'grid'}
        onClick={handleClick('grid')}
      >
        <AppsIcon />
      </IconButton>
      <IconButton
        type="button"
        aria-label="List view"
        aria-pressed={selected === 'list'}
        $active={selected === 'list'}
        onClick={handleClick('list')}
      >
        <ListIcon />
      </IconButton>
    </Root>
  );
};

FileLayoutSelector.displayName = 'FileLayoutSelector';

const Root = styled('div')({
  display: 'flex',
  gap: 8,
});

const IconButton = styled('button', {
  shouldForwardProp: shouldForwardProp('$active'),
})<{ $active: boolean }>(({ theme, $active }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 32,
  height: 32,
  padding: 4,
  border: 'none',
  borderRadius: 4,
  cursor: 'pointer',
  backgroundColor: $active ? theme.palette.gray.light2 : 'transparent',
  color: theme.palette.gray.main,
  '&:hover': {
    color: $active ? theme.palette.gray.main : theme.palette.gray.dark1,
  },
}));

export { FileLayoutSelector };
export type { FileLayoutSelectorLayout, FileLayoutSelectorProps };
